export default function ProgramOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-rose-100 px-6 py-2 rounded-full mb-6">
            <span className="text-sm font-bold text-rose-600 tracking-wider">
              EDUCATOR SYSTEM
            </span>
          </div>
          <h2 className="text-3xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6">
            Miss Mirage エデュケーターシステムとは？
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          {/* 左側：フローチャート */}
          <div className="lg:col-span-2">
            <div className="space-y-8">
              {/* Step 1 */}
              <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-8 border-2 border-rose-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-48 h-48 opacity-10">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/d2e76638bf8be25563fb149d309dbe50.jpg"
                    alt="Miss Mirage Products"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 relative z-10">
                  Miss Mirage
                </h3>
                <div className="flex flex-wrap gap-3 relative z-10">
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-rose-200">
                    公式テキスト
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-rose-200">
                    教育内容の基準
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-rose-200">
                    商材・理論
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-4xl text-rose-400"></i>
              </div>

              {/* Step 2 */}
              <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 border-2 border-amber-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-48 h-48 opacity-10">
                  <img 
                    src="https://readdy.ai/api/search-image?query=professional%20nail%20educator%20receiving%20certification%20award%20ceremony%20elegant%20certificate%20presentation%20modern%20beauty%20school%20setting%20warm%20lighting%20achievement%20moment%20inspiring%20atmosphere&width=400&height=400&seq=system002&orientation=squarish"
                    alt="Educator Certification"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 relative z-10">
                  エデュケーター認定<br />
                  <span className="text-lg font-normal text-gray-600">（サロン／スクール）</span>
                </h3>
                <div className="flex flex-wrap gap-3 relative z-10">
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-amber-200">
                    教える権利を持つ
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-amber-200">
                    公式カリキュラムを使用
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-amber-200">
                    スクール運営が可能
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-4xl text-rose-400"></i>
              </div>

              {/* Step 3 */}
              <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 border-2 border-emerald-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-48 h-48 opacity-10">
                  <img 
                    src="https://readdy.ai/api/search-image?query=nail%20instructor%20teaching%20student%20in%20bright%20modern%20classroom%20hands-on%20training%20session%20professional%20education%20environment%20focused%20learning%20atmosphere%20clean%20organized%20workspace%20natural%20lighting&width=400&height=400&seq=system003&orientation=squarish"
                    alt="Training Students"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 relative z-10">
                  公式テキストを使って<br />ネイリストを育成できる
                </h3>
                <div className="flex flex-wrap gap-3 relative z-10">
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-emerald-200">
                    未経験〜実務レベル
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-emerald-200">
                    サロン就職・独立対応
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 border border-emerald-200">
                    Mirage商材で教育
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-4xl text-rose-400"></i>
              </div>

              {/* Step 4 */}
              <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 border-2 border-violet-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-48 h-48 opacity-10">
                  <img 
                    src="https://readdy.ai/api/search-image?query=successful%20nail%20school%20business%20owner%20in%20modern%20elegant%20salon%20interior%20professional%20achievement%20business%20growth%20concept%20bright%20welcoming%20space%20organized%20workspace%20prosperity%20atmosphere&width=400&height=400&seq=system004&orientation=squarish"
                    alt="School Management"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 relative z-10">
                  スクール運営・人材育成・教育収益
                </h3>
              </div>
            </div>
          </div>

          {/* 右側：一文定義 */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 bg-gradient-to-br from-rose-500 to-pink-500 rounded-2xl p-6 sm:p-10 text-white shadow-2xl text-center">
              <div className="mb-4 sm:mb-6">
                <i className="ri-lightbulb-line text-4xl sm:text-5xl"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 leading-tight">
                エデュケーター<br className="sm:hidden" />システムとは
              </h3>
              <p className="text-base sm:text-lg leading-relaxed font-medium">
                メーカーの公式テキストを使って<br />
                ネイリスト教育・<br className="sm:hidden" />スクール運営ができる<br />
                <strong className="text-xl sm:text-2xl">認定制度</strong> です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
